import React from 'react';
import Svg, {SvgProps, Circle, Path} from 'react-native-svg';

const ApplicationStepperCross = (props: SvgProps) => {
    return (
        <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <Circle cx="10" cy="10" r="9.5" fill="white" stroke="#FD3333" />
            <Circle cx="10" cy="10" r="8" fill="#FD3333" />
            <Path
                d="M12.7808 11.7225C12.8503 11.792 12.9054 11.8745 12.943 11.9653C12.9806 12.0561 13 12.1534 13 12.2517C13 12.3499 12.9806 12.4473 12.943 12.538C12.9054 12.6288 12.8503 12.7113 12.7808 12.7808C12.7113 12.8503 12.6288 12.9054 12.538 12.943C12.4473 12.9806 12.3499 13 12.2517 13C12.1534 13 12.0561 12.9806 11.9653 12.943C11.8745 12.9054 11.792 12.8503 11.7225 12.7808L10 11.0583L8.27747 12.7808C8.13713 12.9212 7.94679 13 7.74832 13C7.54986 13 7.35952 12.9212 7.21918 12.7808C7.07884 12.6405 7 12.4501 7 12.2517C7 12.0532 7.07884 11.8629 7.21918 11.7225L8.94171 10L7.21918 8.27747C7.07884 8.13713 7 7.94679 7 7.74832C7 7.54986 7.07884 7.35952 7.21918 7.21918C7.35952 7.07884 7.54986 7 7.74832 7C7.94679 7 8.13713 7.07884 8.27747 7.21918L10 8.94171L11.7225 7.21918C11.8629 7.07884 12.0532 7 12.2517 7C12.4501 7 12.6405 7.07884 12.7808 7.21918C12.9212 7.35952 13 7.54986 13 7.74832C13 7.94679 12.9212 8.13713 12.7808 8.27747L11.0583 10L12.7808 11.7225Z"
                fill="white"
            />
        </Svg>
    );
};

export default ApplicationStepperCross;
